class ProductModal extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['modal', 'close', 'backdrop']
  }

  static get requiredExternalElements () {
    return ['trigger']
  }

  checkValidity () {
    super.checkValidity()

    if (!this.parent) {
      this.throwError(`No parent with ${this.parentSelector} selector exists`)
    }
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onCloseClick = this.onCloseClick.bind(this)
    this.onEscapePress = this.onEscapePress.bind(this)

    this.listeners.add(
      this.externalEls.trigger.element,
      'click',
      this.onTriggerClick,
    )
    this.listeners.add(this.els.close.element, 'click', this.onCloseClick)
    this.listeners.add(this.els.backdrop.element, 'click', this.onCloseClick)
    this.listeners.add(document, 'keyup', this.onEscapePress)
  }

  onTriggerClick () {
    this.els.modal.element.setAttribute('data-hidden', false)

    if (this.modalState) {
      document.body.classList.add('util-SiteOverflowed')
    }
  }

  onCloseClick () {
    this.els.modal.element.setAttribute('data-hidden', true)

    if (this.modalState) {
      document.body.classList.remove('util-SiteOverflowed')
    }
  }

  onEscapePress (event) {
    if (event.key === 'Escape') {
      this.els.modal.element.setAttribute('data-hidden', true)

      if (this.modalState) {
        document.body.classList.remove('util-SiteOverflowed')
      }
    }
  }

  get parentSelector () {
    return `[data-${this.identifier}-parent]`
  }

  get parent () {
    return this.closest(this.parentSelector)
  }

  get modalState () {
    return this.els.modal.element.getAttribute('data-hidden')
  }
}

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', ProductModal)
}
